import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timeout"
export default class extends Controller {
	static targets = ["restzeit"]

	static values = {
		timeoutMilliseconds: Number,
	}

	connect() {
		// this.SICHTBAR_UNTER_MILLISEKUNDEN = 60 * 1000
		this.aktiv = true
		this.updateTimeout()

		document.addEventListener("turbo:before-fetch-response", this.updateTimeout.bind(this))
		this.checkTimeout()
	}

	disconnect() {
		this.aktiv = false
		document.removeEventListener("turbo:before-fetch-response", this.updateTimeout.bind(this))
	}

	// Private Methods

	updateTimeout() {
		this.timeoutAt = Date.now() + this.timeoutMillisecondsValue
	}

	checkTimeout() {
		const remainingTime = this.timeoutAt - Date.now()

		//this.updateRestzeitAnzeige(remainingTime)

		if (remainingTime <= 0) {
			fetch("/check_user_timeout")
				.then((response) => response.json())
				.then((data) => {
					if (!data.logged_in) {
						this.redirectToLogin() // Redirect to login page
						return
					}
				})
				.catch((error) => {
					console.error("Error:", error)
				})
		}

		if (this.aktiv) setTimeout(this.checkTimeout.bind(this), 5000)
	}

	redirectToLogin() {
		// console.info("Automatische Weiterleitung an die Login Page")
		window.location.href = `/login?last_url=${encodeURIComponent(window.location.href)}`
	}

	// // Methoden zur Ansicht der Restzeit
	// updateRestzeitAnzeige(restzeitInMillisekunden) {
	// 	if (this.hasRestzeitTarget) {
	// 		this.restzeitTarget.innerHTML = this.formatTime(Math.ceil(restzeitInMillisekunden / 1000))
	// 	}
	// }

	// formatTime(seconds) {
	// 	const minuten = Math.floor(seconds / 60)
	// 	const restlicheSekunden = seconds % 60
	// 	return `${String(minuten).padStart(2, "0")}:${String(restlicheSekunden).padStart(2, "0")}`
	// }
}
